<template>
  <v-container fluid id="contact">
    <v-row justify="center" align="center" class="mt-md-16 mt-xs-0">
      <span
        style="
          font-family: Roboto !important;
          font-size: 600 !important;
          color: var(--var2);
        "
        class="text-h6 text-sm-h6 text-md-h5 text-lg-h4 text-xl-h4 mb-8"
        >Contact Me</span
      >
    </v-row>
    <v-row justify="center" align="center" class="mb-10">
      <v-col cols="12">
        <v-row justify="center">
          <v-col cols="12" sm="10" md="8" lg="6">
            <v-card ref="form" elevation="24" style="background: #0e173c">
              <form class="ma-4 pa-4" ref="form" @submit.prevent="sendEmail">
                <v-text-field
                  dark
                  v-model="name"
                  :error-messages="nameErrors"
                  :counter="20"
                  label="Nama"
                  required
                  @input="$v.name.$touch()"
                  @blur="$v.name.$touch()"
                ></v-text-field>
                <v-text-field
                  dark
                  v-model="email"
                  :error-messages="emailErrors"
                  label="E-mail"
                  required
                  @input="$v.email.$touch()"
                  @blur="$v.email.$touch()"
                ></v-text-field>
                <v-textarea
                  dark
                  v-model="message"
                  :error-messages="messageErrors"
                  :counter="200"
                  label="Masukkan Pesan"
                  required
                  @input="$v.message.$touch()"
                  @blur="$v.message.$touch()"
                  rows="1"
                  prepend-icon="mdi-comment"
                ></v-textarea>

                <v-btn
                  style="background: var(--var5)"
                  class="mr-4"
                  type="submit"
                  :loading="loading"
                  value="Send"
                >
                  submit
                </v-btn>
                <v-btn style="background: var(--var5)" @click="clear"> clear </v-btn>
              </form>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
import emailjs from "@emailjs/browser";

export default {
  mixins: [validationMixin],

  validations: {
    name: { required, minLength: minLength(5) },
    email: { required, email },
    message: { required, minLength: minLength(10) },
  },

  data: () => ({
    name: "",
    email: "",
    message: "",
    loading: false,
  }),

  computed: {
    nameErrors() {
      const errors = [];
      if (!this.$v.name.$dirty) return errors;
      !this.$v.name.minLength && errors.push("Nama Paling Sedikit Memiliki 5 Huruf");
      !this.$v.name.required && errors.push("Nama Harus Di Isi.");
      return errors;
    },
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email &&
        errors.push("Email Harus Valid | Contoh : contoh@gmail.com");
      !this.$v.email.required && errors.push("E-mail Harus Di Isi");
      return errors;
    },
    messageErrors() {
      const errors = [];
      if (!this.$v.message.$dirty) return errors;
      !this.$v.message.minLength && errors.push("Masukkan Pesan Paling Sedikit 10 Huruf");
      !this.$v.message.required && errors.push("Pesan Harus Di Isi");
      return errors;
    },
  },

  methods: {
    submit() {
      this.$v.$touch();
    },
    sendEmail() {
      this.loading = true; // Set loading to true when form is submitted
      emailjs
        .send(
          "service_1ll4xq5",
          "template_5qqgpbq",
          {
            from_name: this.name,
            to_name: "BangPutsGans27",
            to_email: this.email,
            message: this.message,
          },
          "zlTuXlb2DYKzYBSd2"
        )
        .then(
          () => {
            this.$toastr.s("Your Message Has Been Sent", "Thank You");
            this.$v.$reset();
            this.name = "";
            this.email = "";
            this.message = "";
            this.loading = false; // Set loading back to false after email is sent
          },
          (error) => {
            console.log("FAILED...", error.text);
            this.loading = false; // Set loading back to false if email sending fails
          }
        );
    },
    clear() {
      this.$v.$reset();
      this.name = "";
      this.email = "";
      this.message = "";
    },
  },
};
</script>
